import { WebAuth } from "auth0-js";
import { channel, buffers } from "redux-saga";
import "@grandvisionhq/utils";
let webAuth;
let authOptions;
const dbConnection = "Username-Password-Authentication";
const assertInit = {
  isInitialized() {
    if (!webAuth) {
      return new Error(
        "WebAuth hasn't been initialized. Make sure you call `init` before any other operations."
      );
    }
  },
  throwIfUninitialized() {
    const error = assertInit.isInitialized();
    if (error !== void 0) {
      throw error;
    }
  },
  async rejectIfUninitialized(callback) {
    const error = assertInit.isInitialized();
    if (error) {
      return Promise.reject(error);
    }
    return new Promise(callback);
  }
};
const renewalRequired = channel(buffers.none());
let renewalTimeoutToken;
function scheduleRenewal(expiresIn) {
  window.clearTimeout(renewalTimeoutToken);
  renewalTimeoutToken = window.setTimeout(
    () => {
      renewalRequired.put({
        type: "@@auth/RENEWAL_REQUIRED"
      });
    },
    expiresIn * 1e3 - 5e3
  );
}
function init(options) {
  authOptions = options;
  webAuth = new WebAuth(authOptions);
}
function authorize(options) {
  assertInit.throwIfUninitialized();
  webAuth.authorize(options);
}
async function checkSession(options = {}) {
  return assertInit.rejectIfUninitialized((resolve, reject) => {
    webAuth.checkSession(options, (err, authResult) => {
      if (err) {
        reject(err);
        return;
      }
      if (!authResult) {
        reject(new Error(`Failed to checkSession, authResult was null`));
        return;
      }
      if (authResult.expiresIn) {
        scheduleRenewal(authResult.expiresIn);
      }
      resolve(authResult);
    });
  });
}
async function crossOriginAuthentication(email, password, options = {}) {
  return assertInit.rejectIfUninitialized((resolve, reject) => {
    webAuth.login(
      {
        ...options,
        username: email,
        realm: dbConnection,
        password,
        // @ts-ignore (types of auth0-js package are not complete
        responseType: "token id_token",
        state: JSON.stringify({ email })
      },
      (err, result) => {
        if (err) {
          reject(err);
          return;
        }
        resolve(result);
      }
    );
  });
}
async function parseHash(options) {
  return assertInit.rejectIfUninitialized((resolve, reject) => {
    const callback = (err, authResult) => {
      if (err) {
        reject(err);
        return;
      }
      if (!authResult) {
        reject(new Error(`Failed to parseHash, authResult was '${authResult}'`));
        return;
      }
      if (authResult.expiresIn) {
        scheduleRenewal(authResult.expiresIn);
      }
      resolve(authResult);
    };
    if (options) {
      webAuth.parseHash(options, callback);
    } else {
      webAuth.parseHash(callback);
    }
  });
}
async function userInfo(accessToken) {
  if (!accessToken) {
    throw new Error("accessToken needs to be non-empty");
  }
  return assertInit.rejectIfUninitialized((resolve, reject) => {
    webAuth.client.userInfo(accessToken, (err, userResult) => {
      if (err) {
        reject(err);
        return;
      }
      resolve(userResult);
    });
  });
}
function logout(returnTo) {
  assertInit.throwIfUninitialized();
  window.clearTimeout(renewalTimeoutToken);
  webAuth.logout({
    returnTo
  });
}
export {
  authorize,
  checkSession,
  crossOriginAuthentication,
  init,
  logout,
  parseHash,
  renewalRequired,
  userInfo
};
//# sourceMappingURL=auth.js.map
